import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';

// Inicializamos Mercado Pago con la Public Key

const publickey = process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY || import.meta.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY;



initMercadoPago(publickey);

const PaymentsML = () => {
  const { trackingCode } = useParams();
  const [preferenceId, setPreferenceId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [monto, setMonto] = useState(0);

  // Función para crear la preferencia de pago
  const createPreference = async () => {
    try {
      const response = await fetch('https://frabas.cl/backend/create_preference.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          trackingCode,
          monto,
          description: `Pago código ${trackingCode}`,
        }),
      });

      const data = await response.json();
      return data.id;
    } catch (error) {
      console.error('Error al crear preferencia:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obtener el monto desde tu API
        const response = await fetch("https://frabas.cl/backend/pago.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ codigo: trackingCode })
        });

        const data = await response.json();
        if (data.success) {
          setMonto(data.data.monto);
          // Una vez que tenemos el monto, creamos la preferencia
          const preference = await createPreference();
          setPreferenceId(preference);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [trackingCode]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-[#009ee3] text-white py-20">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Pago con Mercado Pago</h1>
            <p className="text-xl md:text-2xl">Complete su pago de forma segura</p>
          </div>
        </div>
      </div>

      {/* Contenido Principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Detalles del Pago */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-[#009ee3] mb-6">Detalles del Pago</h2>
            <div className="space-y-6">
              <div className="p-4 bg-gray-100 rounded-lg">
                <p className="text-gray-700">Código de Seguimiento: <span className="font-bold">{trackingCode}</span></p>
              </div>
              
              {loading ? (
                <div className="text-center py-4">
                  <p>Cargando detalles del pago...</p>
                </div>
              ) : (
                <div className="space-y-4">
                  <div className="p-4 bg-gray-100 rounded-lg">
                    <p className="text-2xl font-bold text-gray-900">Monto a pagar:</p>
                    <p className="text-3xl font-bold text-[#009ee3]">${monto.toLocaleString('es-CL')}</p>
                  </div>
                  
                  {preferenceId && (
                    <div className="w-full flex justify-center">
                      <Wallet initialization={{ preferenceId }} />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Información de Seguridad */}
          <div className="space-y-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-3xl font-bold text-[#009ee3] mb-6">Pago Seguro con Mercado Pago</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#009ee3] p-3 rounded-full">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">Plataforma Segura</h3>
                    <p className="text-gray-600">Mercado Pago protege tu dinero y datos personales</p>
                  </div>
                </div>

                {/* ... resto de los elementos de seguridad ... */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsML;